import { QuickLink, TextField } from "components";
import TextArea from "elements/Input/TextArea";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const OtherCounties = () => {
	const { next, otherCountiesValue, setOtherCountiesValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName:
				constants.EVENTS.Exemptions_Flow_Other_Property_Counties_Answer,
			data: {
				"Other Property Counties": otherCountiesValue,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Other Property Counties": otherCountiesValue,
		};
		next({ trackingEventData });
	};

	const handleSkip = () => {
		trackEvent({
			eventName:
				constants.EVENTS.Exemptions_Flow_Other_Property_Counties_Answer,
			data: {
				"Other Property Counties": "No Other Properties",
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Other Property Counties": "No Other Properties",
		};
		next({ trackingEventData });
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>If you own other properties in Texas, please list the counties.</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					The county requires this information to ensure there will be no
					duplicate homestead exemptions.
				</p>
				<TextArea
					placeholder="List counties using commas. Ex: Travis, Bastrop, Williamson"
					maxLength={2000}
					rows={4}
					value={otherCountiesValue ?? ""}
					onChange={e => setOtherCountiesValue(e.target.value)}
				/>
			</div>
			<ButtonV2 size="large" disabled={!otherCountiesValue} type="submit">
				Continue
			</ButtonV2>
			<div className="exemption-survey-skip">
				<QuickLink asButton onClick={() => handleSkip()}>
					No Other Properties
				</QuickLink>
			</div>
		</form>
	);
};

export default OtherCounties;
